
import { computed, defineComponent, nextTick, onMounted, ref } from "vue";
import BaseModal from "@/components/base/BaseModal.vue";
import BaseButton from "@/components/base/BaseButton.vue";
import { useStore } from "@/store";

export default defineComponent({
  name: "ActivateRateModal",
  setup(props, { emit }) {
    const store = useStore();
    const activatedInfo = computed(() => store.getters.getSelectedRate);
    const loading = ref(false);
    const subtitle = computed(() => `С вашего баланса спишется ${activatedInfo.value.price} ₸`);
    const date = ref(new Date());
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const formatted = date.value.toLocaleDateString("ru-RU", options);
    const hasActiveSubscription = computed(() => store.getters.hasSubscriptions);
    const activeSubscription = computed(() => {
      return store.getters.subscriptions.find((sub) => sub.is_active);
    });

    const handleSubmit = () => {
      loading.value = true;
      store
        .dispatch("buySubscription", activatedInfo.value.type)
        .then(async () => {
          await store.dispatch("getSubscription");
          await store.dispatch("getTransactions");
          await store.dispatch("getAccount");
          await nextTick(() => {
            emit("click-activate");
          });
        })
        .finally(() => {
          loading.value = false;
        });
    };

    const handleCancel = () => {
      if (!hasActiveSubscription.value) {
        store.commit("setSelectedRateTypeId", null);
      }
      if (hasActiveSubscription.value && activeSubscription.value) {
        store.commit("setSelectedRateTypeId", activeSubscription.value.type);
      }
      emit("cancel");
    };

    return {
      subtitle,
      formatted,
      activatedInfo,
      handleSubmit,
      handleCancel,
      loading,
    };
  },
  components: {
    BaseButton,
    BaseModal,
  },
});
